import type { SVGProps } from 'react';

export const LayoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M19.0002 2.66699H5.00016C2.9775 2.66699 1.3335 4.31099 1.3335 6.33366V17.667C1.3335 19.6897 2.9775 21.3337 5.00016 21.3337H19.0002C21.0228 21.3337 22.6668 19.6897 22.6668 17.667V6.33366C22.6668 4.31099 21.0228 2.66699 19.0002 2.66699ZM20.6668 17.667C20.6668 18.5857 19.9188 19.3337 19.0002 19.3337H9.3335V4.66699H19.0002C19.9188 4.66699 20.6668 5.41499 20.6668 6.33366V17.667Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
